import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Modal, ModalHeader, ModalBody, Button, Badge, ModalFooter } from 'reactstrap'
import CardComando from '../../components/CardComando'
import mascaraParametrizacao from '../../components/MascaraParametrizacao'
import socketSettings from '../../utils/socket/socketSettings'
import ModalImage from '../../components/ModalImage'
import AutomacaoStatus from './AutomacaoStatus'
import ChangeMonitorado from './ChangeMonitorado'
import ReactDOMServer from 'react-dom/server'
import ReactECharts from 'echarts-for-react'
import ReactLoading from 'react-loading'
import Mapa from '../../components/Mapa'
import { Link } from 'react-router-dom'
import Table from '../../components/Table'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import { has, isBoolean, object } from 'underscore'
import { divIcon } from 'leaflet'
import helper from '../../utils/helper'
import Alerta from '../Alerta'
import axios from 'axios'
import GenericDatePicker from '../../components/GenericDatePicker';
import { getVolumeChartGroupByMessage } from '../../utils/volumeMessages'
import isEqual from "lodash/isEqual";
import demoSession from '../../tours/demo/DemoSession'

class MonitoradoStatus extends Component {
    mapRef = null
    userInfo = auth.getUserInfo()

    state = {
        monitorado: { equipamentos: [], fotos: [], parametros: [], automacoes: [], automacoesAtivas: 0 },
        detalhes: { cliente: [], data: new Date().toISOString().split("T")[0] },
        chart: null,
        chartGroup: null,
        selectedParam: null,
        chartLoading: true,
        comandos: [],
        reportes: {},
        pageSize: 10,
        totalMoveSlides: 0,
        actualMoveSlides: 0,
        totalMoveSlidesComando: 0,
        actualMoveSlidesComando: 0,
        equipamentoSelecionado: null,
        position: [0, 0],
        tabs: { alerta: 0, equipamentos: 0, automacao: 0 },
        modal: { automacao: false, alerta: false, fotos: false, mapa: false, selectParams: false, mapChoiceModal: false },
        datePicker: {
            grafico: { startDate: new Date(), endDate: new Date() },
            mapa: { startDate: new Date(), endDate: new Date() },
            eventos: { startDate: new Date(), endDate: new Date() },
            csv: { startDate: new Date(), endDate: new Date() }
        },
        map: { position: [0, 0], markers: [] },
        autoReload: true,
        disableLoadMore: false,
        buttonCsv: false,
        title: null,
        orderParams: false,
        paramOrigin: null,
        rowLimitSelected: 10,
        trackerParams: {
            latitudeParam: {
                selected: true,
                hasParam: false,
                objParam: {}
            },
            longitudeParam: {
                selected: false,
                hasParam: false,
                objParam: {}
            }
        },
        trackerPositions: false,
        zoom: 4
    }

    componentDidMount = () => {
        this.getData()
        this.getComandos()
    }

    componentWillUnmount() {
        socketSettings.disconnectRoom("close.dashboard", "join.dashboard", "update.dashboard")
    }

    getData = () => {
        const configMe = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() } }
        const requestURL = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/monitorado-status/${this.props.match.params.id}/`

        axios.get(requestURL, configMe).then(async (res) => {
            let selectedParam = this.state.selectedParam
            const monitorado = res.data

            if (monitorado?.parametros?.length > 0) {
                if (selectedParam == null) {
                    selectedParam = monitorado.parametros[0]
                }

                this.getChart()
            } else {
                this.setState({ chartLoading: false })
            }

            monitorado.automacoesAtivas = monitorado?.equipamentos?.filter(equipamento => {
                let ativas = 0

                equipamento?.validacao?.automacoes?.forEach((auto) => {
                    if (auto?.esta_ativo) {
                        ativas++
                    }
                })

                return ativas > 0
            })?.length ?? 0

            let { markers } = this.state.map
            let position = [monitorado.latitude, monitorado.longitude]

            markers.push({
                latitude: monitorado.latitude,
                longitude: monitorado.longitude,
                icon: monitorado?.tipo.icone,
                iconElement: this.createDivIcon(monitorado, false, monitorado?.tipo?.icone),
                condicoes: monitorado.condicoes,
                campos: monitorado.parametros.map((parametro) => ({ campo__equipamento__usuario_mqtt: parametro.campo.equipamento.usuario_mqtt })),
                nome: monitorado.nome,
                defaultColor: monitorado?.tipo?.default_cor
            })

            if (this.mapRef != null) {
                this.mapRef.current.setView(position, 4)
            }

            this.setState({ monitorado, selectedParam, markers, position })
            this.quantidadeSlides("parametro")

            let devices = monitorado.equipamentos.map((equipamento) => equipamento.usuario_mqtt)

            if (markers.length > 0 && devices.length > 0) {
                const methodsUpdate = [
                    { descriptionMethod: "update_markers", parameters: { markers, sendMarkers: this.receiveMarkersSocket, createDivIcon: this.createDivIcon } },
                    { descriptionMethod: "update_parameters", parameters: { parametros: monitorado.parametros, sendParameters: this.receiveParameters } }
                ]

                socketSettings.connectRoom("join.dashboard", "update.dashboard", devices, methodsUpdate)
            }
        }).catch(console.error)
    }

    receiveMarkersSocket = (marker) => {
        let map = this.state.map
        map.markers = marker
        this.setState({ map })
    }

    receiveParameters = (parameters, event) => {
        let { autoReload, reportes, selectedParam, chartSeries, xAxis, chart, equipamentoSelecionado, chartGroup, datePicker } = this.state;

        const monitorado = this.state.monitorado
        const today = new Date().toLocaleDateString("pt-BR");
        const eventsStartDate = new Date(datePicker.eventos.startDate * 1000).toLocaleDateString("pt-BR");
        const eventsEndDate = new Date(datePicker.eventos.endDate * 1000).toLocaleDateString("pt-BR");
        const haveToday = (today === eventsEndDate || (today === eventsStartDate && today === eventsEndDate));

        monitorado.parametros.forEach((parametro) => {
            let parameter = parameters.filter((item) => item.id == parametro.id)

            if(parameter.length > 0) {
                parametro = parameter[0]
            }
        })

        if (!autoReload || !selectedParam) return

        if (!equipamentoSelecionado || event?.id_dispositivo != equipamentoSelecionado.usuario_mqtt) return

        try {
            let deviceKey = equipamentoSelecionado.imei
            let row = { rowId: helper.randomKey(8) }
            let keys = equipamentoSelecionado.validacao.parametros.map((parametro) => parametro?.identificacao)

            row["data_hora"] = new Date(event?.timestamp_dispositivo * 1000).toLocaleDateString("pt-BR", {
                hour: "numeric", minute: "numeric", second: "numeric"
            }).replace(",", "")

            keys.forEach((key) => {
                if(key in event) {
                    row[key] = event[key]
                }
            })
            if (haveToday) {
                reportes[deviceKey].data.unshift(row);
                reportes[deviceKey].data = reportes[deviceKey].data.slice(0);

                this.setState({ reportes });
            }

        } catch (err) {
            console.error(err)
        }

        try {
            if (chart != null) {
                const find = parameters?.find((param) => param.campo.identificacao == selectedParam.campo.identificacao)
                const chartStartDate = new Date(datePicker.grafico.startDate * 1000).toLocaleDateString("pt-BR");
                const chartEndDate = new Date(datePicker.grafico.endDate * 1000).toLocaleDateString("pt-BR");
                const chartIsToday = today === chartStartDate && today === chartEndDate;

                if (find) {
                    if (chartGroup === 'day' || !chartIsToday) return

                    let date = new Date(event?.timestamp_dispositivo * 1000).toLocaleString("pt-BR", { hour: "numeric", minute: "numeric" })
                    chartSeries[0].data.push(find?.valor_atual ?? '---')

                    xAxis.push(date)
                    this.setState({ chartSeries, xAxis })
                    this.renderChart(null, true)
                }
            }
        } catch (err) {
            console.error(err)
        }

        this.setState({ monitorado })
    }

    getComandos = () => {
        axios({
            method: "GET",
            url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/monitorado-comando/?limit=100&monitorado=${this.props.match.params.id}`,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(res => {
            let monitoradoComandos = []
            res.data?.results?.forEach((comando) => monitoradoComandos.push(comando.comando))

            this.setState({ comandos: monitoradoComandos })
            this.quantidadeSlides("comando")
        }).catch(console.error)
    }

    quantidadeSlides = (tipo) => {
        setTimeout(() => {
            let widthVision = document.getElementById(`slide-${tipo}`)?.clientWidth
            let widthList = document.getElementById(`list-${tipo}`)?.clientWidth / 2
            let moveSlide = Math.ceil((widthVision / widthList)) - 2

            if (Math.sign(moveSlide) === -1 || Math.sign(moveSlide) === -0) {
                moveSlide = 0
            }

            this.setState(tipo === "parametro" ? { totalMoveSlides: moveSlide } : { totalMoveSlidesComando: moveSlide })
        }, 2000)
    }

    slideMove = (direcao, tipo) => {
        let newValue = 0
        let actualMoveSlides = tipo === "parametro" ? this.state.actualMoveSlides : this.state.actualMoveSlidesComando
        let totalMoveSlides = tipo === "parametro" ? this.state.totalMoveSlides : this.state.totalMoveSlidesComando

        if (direcao) {
            newValue = actualMoveSlides + 1
        } else {
            newValue = actualMoveSlides - 1
        }

        if (newValue > totalMoveSlides)
            newValue = totalMoveSlides

        document.getElementById(`slide-${tipo}`).style.transform = "translateX(" + -Math.abs(newValue * (document.getElementById(`list-${tipo}`).clientWidth) / 2) + "px)"
        this.setState(tipo === "parametro" ? { actualMoveSlides: newValue } : { actualMoveSlidesComando: newValue })
    }

    handleModal = (state) => {
        let { modal } = this.state
        modal[state] = !modal[state]
        this.setState({ modal })
    }

    handleTab = (state, value) => {
        if (state === 'equipamentos') {
            this.setState({ disableLoadMore: false })
        }
        let { tabs } = this.state
        tabs[state] = value
        this.setState({ tabs })
    }

    handleSelectDate = (ranges, state) => {
        let { datePicker } = this.state

        if (state === 'eventos') {
            if (!isEqual(ranges, datePicker[state])) {
                this.setState({ disableLoadMore: false })
            }
        }

        datePicker[state]["startDate"] = ranges?.startDate
        datePicker[state]["endDate"] = ranges?.endDate

        this.setState({ datePicker })
    }

    handleSelectParams (param, value, objParam=false, clear=false) {
        let { trackerParams } = this.state

        Object.keys(trackerParams).forEach(key => {
            trackerParams[key]['selected'] = false
            if (param !== key && objParam) {
                trackerParams[key]['selected'] = true
            }
        })

        if (value) {
            trackerParams[param]['selected'] = value
        }

        if (objParam && trackerParams[param]['hasParam'] === false) {
            trackerParams[param]['hasParam'] = true
            trackerParams[param]['objParam'] = objParam
        } 

        if (clear) {
            trackerParams[param]['objParam'] = {}
            trackerParams[param]['selected'] = true
            trackerParams[param]['hasParam'] = false
        }

        this.setState({trackerParams})
    }

    getReports = (equipamento, reload = false) => {
        this.setState({ equipamentoSelecionado: equipamento })
        const { reportes, datePicker, monitorado } = this.state
        const imei = equipamento.imei
        let campos = []
        let camposRef = {}

        monitorado.parametros.forEach((parametro) => {
            if (parametro?.campo) {
                if (parametro?.campo?.equipamento?.imei == imei) {
                    camposRef[parametro.campo.identificacao] = parametro?.campo
                    campos.push(parametro.campo?.identificacao)
                }   
            }
        })

        const data_inicio_timestamp = datePicker.eventos.startDate;
        const data_fim_timestamp = datePicker.eventos.endDate;

        if (reload || !reportes[imei]?.lastKey) {
            let bodyForm = new FormData()

            bodyForm.append("equipamento", imei)
            bodyForm.append("monitorado", monitorado.id)
            bodyForm.append("data_inicio", data_inicio_timestamp)
            bodyForm.append("data_fim", data_fim_timestamp)

            if (campos.length > 0) {
                bodyForm.append("campos", JSON.stringify(Array.from(new Set(campos))))
            }

            axios({
                url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/monitorado-status-reportes/?limit=${this.state.pageSize}`,
                method: "POST",
                data: bodyForm,
                headers: { 'Authorization': 'Bearer ' + auth.getToken() }
            }).then((res) => {
                const data = res.data?.results ?? []
                const columns = []
                const keys = campos

                if(data?.length < this.state.pageSize) {
                    this.setState({ disableLoadMore: true })
                }

                if (data.length > 0) {
                    columns.push({
                        Header: 'Data',
                        Accessor: 'data_hora',
                        sortable: false,
                        Cell: (original) => {
                            if (original?.data_hora) {
                                return original?.data_hora?.replaceAll(/-/g, "/")
                            } else {
                                return <div>---</div>
                            }
                        }
                    })

                    //try {
                    //    keys = this.state.monitorado.parametros.map(parametro => {
                    //        return parametro.campo.identificacao
                    //    })
                    //} catch (err) {
                    //    console.error(err)
                    //    keys = Object.keys(data?.[0])
                    //}

                    keys?.forEach((key) => {
                        if (key != "data_hora") {
                            columns.push({
                                Header: camposRef[key]?.descricao,
                                Accessor: key,
                                sortable: false,
                                Cell: (original) => {
                                    if (typeof original[key] === 'boolean') {
                                        return (
                                            <Badge color={original[key] ? "success" : "secondary"}>
                                                {original[key] ? "Verdadeiro" : "Falso"}
                                            </Badge>
                                        )
                                    }

                                    if (original[key] == null || original[key] == undefined) return "---"

                                    return `${original[key] ?? "---"} ${camposRef[key]?.unidade ?? ""}`
                                }
                            })
                        }
                    })
                }

                reportes[imei] = { data, columns, lastKey: res.data?.lastKey }
                this.setState({ reportes, loading: false })
            })
        } else {
            this.setState({ loading: true })
            let bodyForm = new FormData()

            bodyForm.append("equipamento", imei)
            bodyForm.append("monitorado", monitorado.id)
            bodyForm.append("last_key", JSON.stringify(reportes[imei]?.lastKey))
            bodyForm.append("data_inicio", data_inicio_timestamp)
            bodyForm.append("data_fim", data_fim_timestamp)

            if (campos.length > 0) {
                bodyForm.append("campos", JSON.stringify(campos))
            }

            axios({
                url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/monitorado-status-reportes/?limit=${this.state.pageSize}`,
                method: "POST",
                data: bodyForm,
                headers: { 'Authorization': 'Bearer ' + auth.getToken() }
            }).then((res) => {
                reportes[imei]["data"] = [...reportes[imei].data, ...res.data?.results]
                reportes[imei]["lastKey"] = res.data.lastKey

                this.setState({ reportes, loading: false })
            })
        }
    }

    addReferenceLineChart = (referencias) => {
        let data = []

        if (referencias?.length > 0) {
            referencias?.forEach((referencia) => {
                data.push({
                    yAxis: Number(referencia.valor),
                    name: referencia.descricao,
                    lineStyle: {
                        color: referencia.cor,
                        width: 1,
                        type: 'dashed',
                    }
                })
            })
        }

        return data
    }

    getChart = async (forceUpdate = false) => {
        await new Promise((res, rej) => setTimeout(() => res(), 5))

        let { datePicker, selectedParam } = this.state

        if (this.state.chart == null) {
            this.setState({ chartLoading: true })
        }

        this.setState({ chart: null })

        let parametro = selectedParam

        const data_inicio_timestamp = datePicker.grafico.startDate;
        const data_fim_timestamp = datePicker.grafico.endDate;

        if (parametro && parametro.campo?.tipo_grafico === "linha") {
            let bodyForm = new FormData()
            bodyForm.append("equipamento", parametro.campo?.equipamento?.imei)
            bodyForm.append("campo", parametro.campo?.identificacao)
            bodyForm.append("campo_id", parametro.campo?.id)
            bodyForm.append("data_inicio", data_inicio_timestamp)
            bodyForm.append("data_fim", data_fim_timestamp)

            await axios({
                url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/monitorado-status-grafico/`,
                method: "POST",
                data: bodyForm,
                headers: { 'Authorization': 'Bearer ' + auth.getToken() }
            }).then((res) => {
                const { data, group, field, campo, extra } = res.data
                const configuracoes = campo.configuracao ? JSON.parse(campo.configuracao) : ""
                let chartSeries = []
                let title = null
                let xAxis = []

                if (group === "hour" && data) {
                    let serie = {
                        name: `${campo?.descricao}`,
                        type: 'line',
                        data: [],
                        markLine: {
                            data: [],
                            label: { position: 'insideStartTop' },
                            symbol: 'circle'
                        }
                    }

                    serie.markLine.data = this.addReferenceLineChart(configuracoes?.referencias)

                    Object.keys(data)?.forEach((key) => {
                        if (Array.isArray(data?.[key])) {
                            data?.[key]?.forEach((item) => {
                                xAxis.push(new Date(item.timestamp_dispositivo * 1000).toLocaleTimeString('pt-BR').slice(0, 5))
                                serie.data.push(item?.[field] ?? '---')
                            })
                        }
                    })

                    chartSeries.push(serie)
                } else if (group === "day") {
                    let series = [
                        { type: 'line', data: [], name: "Máxima", markLine: { data: [], label: { position: 'insideStartTop' }, symbol: 'circle' } },
                        { type: 'line', data: [], name: "Média", markLine: { data: [], label: { position: 'insideStartTop' }, symbol: 'circle' } },
                        { type: 'line', data: [], name: "Mínima", markLine: { data: [], label: { position: 'insideStartTop' }, symbol: 'circle' } },
                    ]
                    
                    Object.keys(data)?.forEach((key) => {
                        xAxis.push(key)
                        series[0].data.push(data?.[key]?.max ?? '---')
                        series[1].data.push(data?.[key]?.med ?? '---')
                        series[2].data.push(data?.[key]?.min ?? '---')
                    })

                    series[0].markLine.data = this.addReferenceLineChart(configuracoes?.referencias)
                    series[1].markLine.data = this.addReferenceLineChart(configuracoes?.referencias)
                    series[2].markLine.data = this.addReferenceLineChart(configuracoes?.referencias)

                    chartSeries = series
                }

                if (!["booleano", "string"].includes(parametro?.campo?.tipo_dado_saida)) {
                    title = `Min: ${extra?.min} | Med: ${extra?.med} | Max: ${extra?.max} (${parametro?.campo?.unidade ?? ""})`
                    title = title?.replaceAll("undefined", "---")
                    title = title?.replaceAll("null", "---")
                }

                this.setState({ chartSeries, xAxis, title, chartGroup: group })
                this.renderChart(null, forceUpdate)
            }).catch(console.error)
        } else if (parametro?.campo?.tipo_grafico === "barra") {
            const configuracoes = parametro.campo.configuracao ? JSON.parse(parametro.campo.configuracao) : ""

            const dispositivos = [{
                id: parametro.campo?.equipamento?.usuario_mqtt,
                field: parametro.campo?.identificacao,
            }]

            const diffInDays = Math.ceil(Math.abs(data_inicio_timestamp - data_fim_timestamp) / (60 * 60 * 24))
            let group = diffInDays > 1 ? "day" : "hour_current"

            let bodyForm = new FormData()
            bodyForm.append("dispositivos", JSON.stringify(dispositivos))
            bodyForm.append("grupo", group)
            bodyForm.append("calcular_projecao", "1")
            bodyForm.append("timestamp_dispositivo_ini", data_inicio_timestamp)
            bodyForm.append("timestamp_dispositivo_fim", data_fim_timestamp)

            await axios({
                url: `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/reporte/consumo/`,
                method: "POST",
                data: bodyForm,
                headers: { 'Authorization': 'Bearer ' + auth.getToken() }
            }).then((res) => {
                const { data } = res.data
                let groupBy = diffInDays >= 1 ? "day" : "hour"
                let title = null
                let xAxis = []

                let chartSeries = {
                    name: parametro?.campo?.descricao,
                    type: 'bar',
                    data: [],
                    markLine: {
                        data: [],
                        label: { position: 'insideStartTop' },
                        symbol: 'circle'
                    }
                }

                Object.keys(data.TOTAL_GROUP).forEach(key => xAxis.push(Number(key)))

                xAxis.forEach(key => {
                    if (data.TOTAL_GROUP[key]) {
                        chartSeries.data.push(data.TOTAL_GROUP[key].diff)
                    } else {
                        chartSeries.data.push(0)
                    }
                })

                if (!["booleano", "string"].includes(parametro?.campo?.tipo_dado_saida)) {
                    title = `Total: ${data?.TOTAL} (${parametro?.campo?.unidade ?? ""})`

                    if (data?.PROJECTION != 0) {
                        if (group == "day") {
                            title += ` | Estimativa do mês: ${data?.PROJECTION} (${parametro?.campo?.unidade ?? ""})`
                        } else if (group == "hour_current") {
                            title += ` | Estimativa do dia: ${data?.PROJECTION} (${parametro?.campo?.unidade ?? ""})`
                        }
                    }
                }

                chartSeries.markLine.data = this.addReferenceLineChart(configuracoes?.referencias)

                if (group == "hour_current") {
                    xAxis = xAxis.map(axis => axis + ":00")
                }

                this.setState({ chartSeries, xAxis, title, chartGroup: group })
                this.renderChart(groupBy, forceUpdate)
            }).catch(console.error)
        }

        this.setState({ chartLoading: false })
    }

    tooltipFormat = (parametro, values) => {
        let html = []

        if (values?.length > 0) {
            html.push(values?.[0]?.axisValue)
        }

        for (let item of values) {
            let mascara = parametro.campo.mascara
            let value = item?.value
            value = value == null || value === '---' ? '---' : mascara === "padrao" ? value : mascaraParametrizacao[mascara](value)
            let unidade = mascara === "padrao" ? parametro?.campo?.unidade : ""

            html.push(
                `<div style="display: flex; align-items: center;">
                    <div style="width: 14px; height: 14px; background-color: ${item?.color}; margin-right: 5px; margin-bottom: 3px; border-radius: 4px;"></div>
                    <strong>${item?.seriesName}:</strong> &nbsp;${value} ${unidade}
                </div>`
            )
        }

        return html.join("")
    }

    renderChart = async (groupBy = null, update = false) => {
        await new Promise((res, rej) => setTimeout(() => res(), 5))

        let { selectedParam, chartSeries, xAxis, title } = this.state
        const isBarChart = selectedParam?.campo?.tipo_grafico === "barra";

        const chart = (
            <ReactECharts
                style={{ height: '370px', width: '100%' }}
                option={{
                    title: { text: title, textStyle: { fontSize: 14 }, ...(isBarChart && { left: 15 })},
                    legend: { top: 20, show: true },
                    grid: { top: 60, right: 10, bottom: 20, left: 50 },
                    series: chartSeries,
                    xAxis: {
                        data: xAxis,
                        name: "name",
                        nameTextStyle: { fontWeight: '600', fontSize: '12' },
                        nameLocation: 'center',
                        axisLabel: {
                            formatter: (value) => groupBy === "hour" ? `${value}:00` : value
                        },
                    },
                    yAxis: {
                        type: 'value',
                        max: (value) => {
                            if (value?.max < 0)
                                return Math.ceil((value.max + (Math.abs(value.max) * 0.05)))
                            return Math.ceil((value.max + (Math.abs(value.max) * 0.05)))
                        },
                        min: (value) => Math.floor(value.min - (Math.abs(value.min) * 0.6)),
                    },
                    tooltip: {
                        show: true,
                        trigger: "axis",
                        axisPointer: { type: "cross", label: { show: true } },
                        extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);',
                        formatter: (values) => this.tooltipFormat(selectedParam, values)
                    },
                    dataZoom: [
                        { type: 'inside', start: 0, end: 100 },
                        {
                            bottom: 0,
                            brushSelect: false, start: 0, end: 10, handleSize: '100%',
                            handleStyle: { borderWidth: '2', borderColor: 'rgba(0, 0, 0, 0.42)' }
                        }
                    ],
                }}
            />
        )

        if (update) {
            this.setState({ chart: null })
            setTimeout(() => this.setState({ chart }), 30)
        } else {
            this.setState({ chart })
        }
    }

    getDataByDay = (state) => {
        let { datePicker, monitorado, modal } = this.state

        if (state === "eventos") {
            this.setState({ reportes: {}, loading: true })
            setTimeout(() => this.state.table?.fetch(), 500)
        } else if (state === "grafico" && monitorado?.parametros?.length > 0) {
            this.setState({ chartLoading: true })
            this.getChart(true)
        } else if (state === "mapa") {
            modal.mapChoiceModal = true
            this.setState({ modal })
        }

        datePicker[state].show = false
        this.setState({ datePicker })
    }

    generateCSV = async (equipamento) => {
        this.setState({ buttonCsv: true })

        const { datePicker, monitorado } = this.state
        const imei = equipamento.imei
        let campos = []

        monitorado.parametros.forEach((parametro) => {
            if (parametro?.campo?.equipamento?.imei == imei) {
                campos.push(parametro.campo?.identificacao)
            }
        })

        let bodyForm = new FormData()

        const dateStart = datePicker.csv.startDate;
        const dateEnd = datePicker.csv.endDate;

        bodyForm.append("equipamento", imei)
        bodyForm.append("monitorado", monitorado.id)
        bodyForm.append("data_inicio", dateStart)
        bodyForm.append("data_fim", dateEnd)

        if (campos.length > 0) {
            bodyForm.append("campos", JSON.stringify(campos))
        }

        await axios({
            url: cfg.base_api_url + cfg.api_v2 + '/' + auth.getUserInfo().empresa + '/monitorado-exportar/',
            method: "POST",
            data: bodyForm,
            headers: { 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (res.status === 200) {
                const filename = `${imei}_${new Date().getTime()}.csv`
                const blob = new Blob([res.data], { type: 'text/csv' })
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.setAttribute('href', url)
                a.setAttribute('download', filename)
                a.click()
            }
        }).catch(console.error)

        this.setState({ buttonCsv: false })
    }

    createDivIcon = (monitorado, status, icon) => {
        return divIcon({
            className: 'default-div-icon',
            iconSize: [32, 64],
            iconAnchor: [16, 64],
            popupAnchor: [0, -64],
            html: ReactDOMServer.renderToString(
                <div className="default-marker-container" style={{ backgroundColor: monitorado?.tipo__cor || monitorado?.tipo?.cor }} title={monitorado?.nome}>
                    <i className={icon + " la-2x"}></i>
                    <div className="default-marker-gradient"></div>
                    <div style={{ backgroundColor: monitorado?.tipo__cor || monitorado?.tipo?.cor }} className="default-marker-triangle"></div>
                </div>
            ),
        })
    }

    habilitOrder = (order) => {
        this.setState({ orderParams: order })

        if (!order) {
            const userInfo = auth.getUserInfo()
            const parametros = this.state.monitorado.parametros.map((item) => item.campo.id)

            axios({
                url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/monitorado-status/${this.props.match.params.id}/ordenar-parametros/`,
                method: "POST",
                data: JSON.stringify({ parametros: parametros }),
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
            })
                .then((response) => {
                    helper.dispatchEvent("showAviso", { message: response.data })
                })
                .catch((error) => {
                    helper.dispatchEvent("showAviso", { message: "Não foi possível salvar a ordenação." })
                })

            this.setState({ paramOrigin: null })
        }
    }

    changeOrderParams = (keyParam) => {
        const { paramOrigin } = this.state
        let monitorado = Object.assign({}, this.state.monitorado)

        if (paramOrigin !== null) {
            const origin = monitorado.parametros[paramOrigin]
            const destiny = monitorado.parametros[keyParam]

            monitorado.parametros[paramOrigin] = destiny
            monitorado.parametros[keyParam] = origin

            this.setState({ monitorado: monitorado, paramOrigin: null })
        } else {
            this.setState({ paramOrigin: keyParam })
        }
    }

    getMapaData(configured=true) {
        // apenas a busca automatica (configured = false) está sendo utilizada
        const { trackerParams, datePicker, monitorado } = this.state
        const { startDate, endDate } = datePicker.mapa

        const configMe = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() } }
        const requestURL = `${cfg.base_api_url + cfg.api_v2}/${this.userInfo.empresa}/monitorado-rotas/`

        const payloadData = {
            'latitude': {
                'id_dispositivo': false,
                'identificacao': false
            },
            'longitude': {
                'id_dispositivo': false,
                'identificacao': false
            },
            'periodo': {
                'data_inicio': startDate,
                'data_fim':  endDate,
            }
        }

        if (configured) {
            payloadData['latitude']['id_dispositivo'] = trackerParams.latitudeParam.objParam.campo.equipamento.usuario_mqtt,
            payloadData['latitude']['identificacao'] = trackerParams.latitudeParam.objParam.campo.identificacao
            payloadData['longitude']['id_dispositivo'] = trackerParams.longitudeParam.objParam.campo.equipamento.usuario_mqtt,
            payloadData['longitude']['identificacao'] = trackerParams.longitudeParam.objParam.campo.identificacao
        } else {
            let xParam = monitorado.parametros.filter(parametro => parametro.campo.identificacao == 'x')
            let yParam = monitorado.parametros.filter(parametro => parametro.campo.identificacao == 'y')

            if (xParam.length > 0 && yParam.length > 0){
                payloadData['latitude']['id_dispositivo'] = yParam[0].campo.equipamento.usuario_mqtt,
                payloadData['latitude']['identificacao'] = yParam[0].campo.identificacao
                payloadData['longitude']['id_dispositivo'] = xParam[0].campo.equipamento.usuario_mqtt,
                payloadData['longitude']['identificacao'] = xParam[0].campo.identificacao
            } else {
                helper.dispatchEvent("showAviso", {
                    message: "Não foi possivel encontrar os parametros x e y."
                })
                let { modal } = this.state
                modal.selectParams = false
                modal.mapChoiceModal = false
                this.setState({trackerPositions: false, modal: modal })
                return
            }
        }

        axios.post(requestURL, payloadData, configMe)
            .then((response) => {
                let { modal } = this.state
                modal.selectParams = false
                modal.mapChoiceModal = false
                if (response.data.length > 0) { 
                    this.setState({trackerPositions: response.data, modal: modal })
                } else {
                    helper.dispatchEvent("showAviso", {
                        message: "Não foi possivel gerar percurso."
                    })
                    this.setState({trackerPositions: false, modal: modal })
                }
            })
            .catch((erro) => {
                helper.dispatchEvent("showAviso", {
                    message: "Não foi possivel gerar percurso."
                })
                let { modal } = this.state
                modal.selectParams = false
                modal.mapChoiceModal = false
                this.setState({trackerPositions: false, modal: modal })
            })
    }

    renderHasParam(parametro, paramType) {
        let mascara
        try {
            mascara = parametro.campo.mascara
        } catch {
            mascara = "padrao"
        }
        let icone = parametro.campo?.icone?.icone_on
        let value = mascara === "padrao" ? String(parametro?.valor_atual) : mascaraParametrizacao[mascara](parametro?.valor_atual)
        let elementValue = value.length > 10 ? `${value.slice(0, 10)} ...` : value
        
        return (
            <div key={parametro.id} className="col-6" style={{ borderRadius: "15px", display: this.state.trackerParams[paramType].hasParam ? "flex" : "none" }} onClick={() => this.handleSelectParams(paramType, false, false, true)}>
                <div className="params-to-select remove-hover">
                    <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <div className='label-truncate' style={{ width: "150px" }} title={parametro.campo?.descricao}>{parametro.campo?.descricao}</div>
                        <div
                            title={parametro.campo?.descricao}
                            style={{
                                width: "10px",
                                height: "10px",
                                background: parametro.campo?.color,
                                borderRadius: "100%"
                            }}>
                        </div>
                    </label>
                    <strong title={value}>{elementValue} {parametro.campo?.unidade}</strong>
                </div>
            </div>
        )
    }

    renderParamsList(monitorado, trackerParams, paramOrigin) {
        const pares = []
        const idsSelected = []
        let parametrosFiltrados = monitorado.parametros

        Object.keys(trackerParams).forEach(key => {
            if (trackerParams[key]?.objParam?.campo?.id) {
                idsSelected.push(trackerParams[key]?.objParam?.campo?.id)
            }
        })

        if (idsSelected.length > 0) {
           parametrosFiltrados = monitorado.parametros.filter(item => !idsSelected.includes(item.campo.id))
        }

        for (let i = 0; i < parametrosFiltrados?.length; i += 2) {
            pares.push(parametrosFiltrados.slice(i, i + 2))
        }

        return pares.map((par, idx) => (
            <div className="row" key={idx} style={{ marginBottom: "8px" }}>
                {par.map((parametro, keyParam) => {
                    let mascara = parametro.campo.mascara
                    let icone = parametro.campo?.icone?.icone_on
                    let value = mascara === "padrao" ? String(parametro?.valor_atual) : mascaraParametrizacao[mascara](parametro?.valor_atual)
                    let elementValue = value.length > 10 ? `${value.slice(0, 10)} ...` : value

                    if (elementValue == "null") {
                        elementValue = "---"
                    }

                    if (isBoolean(parametro?.valor_atual)) {
                        let color = ""

                        if (parametro?.valor_atual) {
                            icone = parametro.campo?.icone?.icone_on
                            color = "#44bb52"
                        } else {
                            icone = parametro.campo?.icone?.icone_off
                            color = "silver"
                        }

                        elementValue = <div style={{ padding: "15px", width: "20px", borderRadius: "30px", background: color }}></div>
                    }

                    let settings = parametro?.campo?.configuracao
                    let color = "transparent"
                    let descricao = ""

                    if (settings != null) {
                        try {
                            settings = typeof settings == "string" ? JSON.parse(settings) : settings
                            let referencias = settings.referencias
                            let menor = []
                            let maior = []

                            if (referencias.length > 0) {
                                referencias.forEach((referencia) => {
                                    if (referencia.condicao.value === "<") {
                                        menor.push(referencia)
                                    } else {
                                        maior.push(referencia)
                                    }
                                })

                                menor = menor.sort((a, b) => { return a.nome < b.nome ? -1 : a.nome > b.nome ? 1 : 0 })
                                maior = maior.sort((a, b) => { return a.nome > b.nome ? -1 : a.nome < b.nome ? 1 : 0 })

                                if (Number(value) > Number(maior[0]?.valor)) {
                                    maior.forEach((item) => Number(value) > Number(item.valor) ? [color, descricao] = [item.cor, item.descricao] : "")
                                } else {
                                    menor.forEach((item) => Number(value) < Number(item.valor) ? [color, descricao] = [item.cor, item.descricao] : "")
                                }
                            }
                        } catch (err) {
                            console.error(err)
                        }
                    }

                    let trackerParamSelected = false
                    Object.keys(trackerParams).forEach(key => {
                        if (trackerParams[key].selected) {
                            trackerParamSelected = key
                        }
                    })

                    return (
                        <div key={parametro.id} className="col-6" style={{ borderRadius: "15px", opacity: keyParam === paramOrigin ? "0.5" : "1" }} onClick={() => this.handleSelectParams(trackerParamSelected, false, parametro)}>
                            <div className="params-to-select add-hover">
                                <div>
                                    <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <div className='label-truncate' style={{width: "150px"}} title={parametro.campo?.descricao}>{parametro.campo?.descricao}</div>
                                        <div
                                            title={descricao}
                                            style={{
                                                width: "10px",
                                                height: "10px",
                                                background: color,
                                                borderRadius: "100%"
                                            }}>
                                        </div>
                                    </label>
                                </div>
                                <strong title={value}>{elementValue} {parametro.campo?.unidade}</strong>
                                <div className='label-truncate' style={{width: "150px"}} title={parametro.campo?.equipamento.imei}>IMEI: {parametro.campo?.equipamento.imei}</div>
                            </div>
                        </div>
                    )
                })}
                {par.length === 1 && <div className="col-6"></div>}
            </div>
        ))
    }

    renderModalSelectParams(modal, trackerParams, monitorado, paramOrigin) {
        return (
            <>
                <Modal isOpen={modal.selectParams} toggle={() => this.handleModal("selectParams")} className="modal-md">
                    <ModalHeader toggle={() => this.handleModal("selectParams")}>Selecione os Parametros</ModalHeader>
                    <ModalBody>
                        <div className='row'>
                            {
                                trackerParams.latitudeParam.hasParam 
                                ?
                                this.renderHasParam(trackerParams.latitudeParam.objParam, "latitudeParam")
                                :
                                <div className='col-6'>
                                    <div 
                                        className={`${trackerParams.latitudeParam.selected ? 'params-empty-selected' : 'params-empty-not-selected '}`} 
                                        onClick={() => this.handleSelectParams("latitudeParam", true)}
                                    >
                                        <div>Selecione um Parametro para Latitude</div>
                                    </div>
                                </div>
                            }
                            {
                                trackerParams.longitudeParam.hasParam
                                ?
                                this.renderHasParam(trackerParams.longitudeParam.objParam, "longitudeParam")
                                :
                                <div className='col-6'>
                                    <div 
                                        className={`${trackerParams.longitudeParam.selected ? 'params-empty-selected' : 'params-empty-not-selected '}`} 
                                        onClick={() => this.handleSelectParams("longitudeParam", true)}
                                    >
                                        <div>Selecione um Parametro para Longitude</div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div style={{borderBottom: "1px solid #dee2e6", margin: "15px 0px"}}></div>
                        <div className="fields-slide flex-column w-100" style={{maxHeight: "315px", overflowY: "auto", overflowX: "hidden"}}>
                            {this.renderParamsList(monitorado, trackerParams, paramOrigin)}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="w-100 d-flex justify-content-end">
                            <button className="hdv-btn-forms hdv-btn-green" onClick={() => this.getMapaData()} disabled={!(trackerParams.latitudeParam.hasParam && trackerParams.longitudeParam.hasParam)}>Gerar</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        )
    }

    renderMapChoiceModal() {
        return (
            <>
                <Modal isOpen={this.state.modal.mapChoiceModal} toggle={() => this.handleModal("mapChoiceModal")} >
                    <ModalHeader toggle={() => this.handleModal("mapChoiceModal")}>Gerar Percurso</ModalHeader>
                    <ModalBody>
                        Deseja gerar o percurso? 
                        Iremos buscar pelos parâmetros x e y. 
                        Certifique-se de que eles existam.
                    </ModalBody>
                    <ModalFooter>
                        <div className="w-100 d-flex justify-content-end">
                            {/* <button className="hdv-btn-forms hdv-btn-default" onClick={() => {this.handleModal("selectParams"), this.handleModal("mapChoiceModal")}} >Seleção Manual</button> */}
                            <button className="hdv-btn-forms hdv-btn-default" onClick={() => this.handleModal("mapChoiceModal")}>Cancelar</button>
                            <button className="hdv-btn-forms hdv-btn-green" onClick={() => this.getMapaData(false)} >Gerar</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        )
    }

    render() {
        const { monitorado, datePicker, selectedParam, chartLoading, orderParams, paramOrigin, pageSize, rowLimitSelected, modal, trackerParams, trackerPositions, chartGroup, disableLoadMore } = this.state
        const isClient = auth.isClient()
        const isDemoMode = demoSession.isActive()

        let trackerLastPosition, trackerMarkers, trackerZoom
        const isBarChart = selectedParam?.campo?.tipo_grafico == "barra";
        
        if (Array.isArray(trackerPositions)) {
            console.log('gerando tracker')
            trackerLastPosition = trackerPositions[trackerPositions.length - 1]
            let trackerObjeto = this.state.map.markers[0]
            trackerObjeto.latitude = trackerLastPosition[0]
            trackerObjeto.longitude = trackerLastPosition[1]
            trackerMarkers = [trackerObjeto]
            trackerZoom = 14
        }
        
        return (
            <div className="hdv-render-div">
                <ModalImage
                    open={this.state.modal.fotos}
                    images={monitorado?.fotos}
                    toggle={() => this.handleModal("fotos")}
                />

                <Modal
                    isOpen={this.state.modal.mapa}
                    toggle={() => this.handleModal("mapa")}
                    className="modal-large">
                    <ModalHeader toggle={() => this.handleModal("mapa")}>Mapa</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-md-12 map-status">
                                <GenericDatePicker
                                    value={datePicker.mapa}
                                    onChange={(e) => this.handleSelectDate(e, "mapa")}
                                    onApply={() => this.getDataByDay("mapa")}
                                    showLabel
                                    emitOnMount
                                    datepickerClass="screen-status-options status-date-picker d-flex justify-content-start mb-2 w-100"
                                    datepickerStyle={{ padding: "0", backgroundColor: "transparent" }}
                                    toggleStyle={{
                                        backgroundColor: '#f8f8f8',
                                        boxShadow: '0 0px 4px rgba(0, 0, 0, 0.45)',
                                        margin: "15px 12px",
                                        color: "#444",
                                        flexDirection: 'row-reverse',
                                        gap: "0.4rem"
                                    }}
                                    panelClass="hdv-datepicker"
                                    panelStyle={{ top: 58, left: 28, padding: '10px' }}
                                />
                                <div style={{ height: "500px", position: "relative" }}>
                                    {
                                        Array.isArray(trackerPositions) 
                                            ?
                                        <Mapa
                                            position={trackerLastPosition}
                                            initialPosition={trackerLastPosition}
                                            markers={trackerMarkers}
                                            style={{ height: "500px", width: "100%", top: "0px" }}
                                            onLoad={(ref) => { this.mapRef = ref }}
                                            allowZoom={true}
                                            zoom={trackerZoom}
                                            trackerPositions={trackerPositions}
                                            layerControl={true}
                                        />
                                            :
                                        <Mapa
                                            position={this.state.position}
                                            initialPosition={this.state.position}
                                            markers={this.state.map.markers}
                                            style={{ height: "500px", width: "100%", top: "0px" }}
                                            onLoad={(ref) => { this.mapRef = ref }}
                                            layerControl={true}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.modal.automacao} toggle={() => this.handleModal("automacao")} className="modal-large">
                    <ModalHeader toggle={() => this.handleModal("automacao")}>Automações</ModalHeader>
                    <ModalBody>
                        {this.state.modal.automacao ?
                            <AutomacaoStatus
                                monitorado={monitorado}
                                customFilter={`&monitorados__contains=${monitorado?.id} `}
                                history={this.props.history}
                                onUpdate={(table) => this.setState({ automacaoTable: table })}
                            />
                            :
                            null
                        }
                    </ModalBody>
                </Modal>

                {this.renderMapChoiceModal()}

                {this.renderModalSelectParams(modal, trackerParams, monitorado, paramOrigin)}

                <Modal isOpen={this.state.modal.alerta} toggle={() => this.handleModal("alerta")} className="modal-large">
                    <ModalHeader toggle={() => this.handleModal("alerta")}>Alertas</ModalHeader>
                    <ModalBody>
                        <Alerta compact customFilter={`&monitorado=${monitorado?.id}`} />
                    </ModalBody>
                </Modal>

                <div className="hdv-default-header mx-3">
                    <div className='d-flex'>
                        <span className="screen-menu-desc">
                            <h4 title={monitorado?.nome}>
                                {monitorado?.nome?.length > 18 ? monitorado?.nome?.substring(0, 18) + "..." : monitorado?.nome}
                            </h4>
                            <div className={monitorado?.nome ? "gray-background" : "hdv-noshow-item"} style={{ maxHeight: "42px" }}>
                                <i className="fa fa-hdd fa-2x"></i>
                            </div>
                        </span>
                        <ChangeMonitorado idMonitorado={this.props.match.params.id} />
                    </div>
                    <div className="afr-header-options inline-menu-options-page">
                        <summary
                            className={orderParams ? "hdv-popover-button gray-background popover-active" : "hdv-popover-button gray-background"}
                            onClick={() => this.habilitOrder(!orderParams)}
                            style={{ display: monitorado?.parametros.length > 0 ? "block" : "none" }}>
                            <i className="las la-exchange-alt la-2x gray-primary"></i>
                            <span>Ordenar Parâmetros</span>
                        </summary>
                        <Link to={`/monitorado/${this.props.match.params.id}/editar?status=true`}>
                            <summary className="hdv-popover-button gray-background" onClick={() => this.handleModal("fotos")}>
                                <i className="fa fa-pen fa-2x gray-primary"></i>
                                <span>Editar</span>
                            </summary>
                        </Link>
                        <summary className="hdv-popover-button gray-background" onClick={() => this.handleModal("fotos")}>
                            <i className="fa fa-camera fa-2x gray-primary"></i>
                            <span>Fotos</span>
                        </summary>
                        <summary className={monitorado.automacoesAtivas > 0 ? "hdv-popover-button gray-background popover-active" : "hdv-popover-button gray-background"} onClick={() => this.handleModal("automacao")}>
                            <i className="fa fa-robot fa-2x gray-primary"></i>
                            <span>Automações</span>
                        </summary>
                        <summary className="hdv-popover-button gray-background" onClick={() => this.handleModal("alerta")}>
                            <i className="fa fa-exclamation-triangle fa-2x gray-primary"></i>
                            <span>Alertas</span>
                        </summary>
                    </div>
                </div>
                <div id='list-parametro' className="fields-list" style={{ display: monitorado?.parametros.length > 0 ? "flex" : "none" }}>
                    <div
                        style={{ display: (this.state.actualMoveSlides == 0) ? "none" : "flex"/*, height: "92px", top: "4px" */ }}
                        onClick={() => this.slideMove(false, "parametro")}
                        className="fields-box-move fields-box-move-left">
                        <i className="fa fa-angle-left fa-2x"></i>
                    </div>
                    <div id='slide-parametro' className="fields-slide">
                        {monitorado?.parametros?.map((parametro, keyParam) => {
                            let mascara = parametro.campo.mascara
                            let icone = parametro.campo?.icone?.icone_on
                            let value = mascara === "padrao" ? String(parametro?.valor_atual) : mascaraParametrizacao[mascara](parametro?.valor_atual)
                            let elementValue = value.length > 10 ? `${value.slice(0, 10)} ...` : value

                            if (elementValue == "null") {
                                elementValue = "---"
                            }

                            if (isBoolean(parametro?.valor_atual)) {
                                let color = ""

                                if (parametro?.valor_atual) {
                                    icone = parametro.campo?.icone?.icone_on
                                    color = "#44bb52"
                                } else {
                                    icone = parametro.campo?.icone?.icone_off
                                    color = "silver"
                                }

                                elementValue = <div style={{ padding: "15px", width: "20px", borderRadius: "30px", background: color }}></div>
                            }

                            let settings = parametro?.campo?.configuracao
                            let color = "transparent"
                            let descricao = ""

                            if (settings != null) {
                                try {
                                    settings = typeof settings == "string" ? JSON.parse(settings) : settings
                                    let referencias = settings.referencias
                                    let menor = []
                                    let maior = []

                                    if (referencias.length > 0) {
                                        referencias.forEach((referencia) => {
                                            if (referencia.condicao.value === "<") {
                                                menor.push(referencia)
                                            } else {
                                                maior.push(referencia)
                                            }
                                        })

                                        menor = menor.sort((a, b) => { return a.nome < b.nome ? -1 : a.nome > b.nome ? 1 : 0 })
                                        maior = maior.sort((a, b) => { return a.nome > b.nome ? -1 : a.nome < b.nome ? 1 : 0 })

                                        if (Number(value) > Number(maior[0]?.valor)) {
                                            maior.forEach((item) => Number(value) > Number(item.valor) ? [color, descricao] = [item.cor, item.descricao] : "")
                                        } else {
                                            menor.forEach((item) => Number(value) < Number(item.valor) ? [color, descricao] = [item.cor, item.descricao] : "")
                                        }
                                    }
                                } catch (err) {
                                    console.error(err)
                                }
                            }

                            return (
                                <div key={parametro.id} style={{ borderRadius: "15px", opacity: keyParam === paramOrigin ? "0.5" : "1" }}>
                                    <div
                                        className={`status-box-field ${selectedParam?.id === parametro.id ? "active" : ""} ${orderParams ? "tremor" : ""}`}
                                        style={{ cursor: chartLoading ? 'default' : 'pointer' }}
                                        onClick={(e) => {
                                            if (orderParams) {
                                                this.changeOrderParams(keyParam)
                                            } else {
                                                if (!chartLoading && e.target.tagName != "I") {
                                                    this.setState({ selectedParam: parametro, chartLoading: true })
                                                    this.getChart()
                                                }
                                            }
                                        }}>
                                        <div className="status-box-bg"></div>
                                        <div>
                                            <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                <div className='label-truncate' style={{width: "150px"}} title={parametro.campo?.descricao}>{parametro.campo?.descricao}</div>
                                                <div
                                                    title={descricao}
                                                    style={{
                                                        width: "10px",
                                                        height: "10px",
                                                        background: color,
                                                        borderRadius: "100%"
                                                    }}>
                                                </div>
                                            </label>
                                        </div>
                                        <strong title={value}>{elementValue} {parametro.campo?.unidade}</strong>
                                        <i id='icon-status' style={{ position: "relative", left: "calc(100% - 84px)", fontSize: "83px", bottom: "calc(100% + 8px)", zIndex: "-1" }} className={`fa ${icone}`}></i>

                                        {!isClient ? (
                                            isDemoMode ? (
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{ pointerEvents: 'none', cursor: 'default', opacity: 0.5 }}
                                                    title="Indisponível no modo demonstração"
                                                    onClick={(event) => event.preventDefault()}
                                                >
                                                    <i className="fa fa-pen fa-2x"></i>
                                                </button>
                                            ) : (
                                                <Link to={`/campo-parametrizado/${parametro.campo?.equipamento?.id}/editar/${parametro?.campo?.id}`}>
                                                    <button type="button"><i className="fa fa-pen fa-2x"></i></button>
                                                </Link>
                                            )
                                        ) : null}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div
                        style={{ display: (this.state.actualMoveSlides == this.state.totalMoveSlides) ? "none" : "flex"/*, height: "92px", top: "4px" */ }}
                        onClick={() => this.slideMove(true, "parametro")}
                        className="fields-box-move fields-box-move-right">
                        <i className="fa fa-angle-right fa-2x"></i>
                    </div>
                </div>

                <div style={{ marginLeft: "0px", marginBottom: "0px" }} className="status-chart-map-box row mb-3">
                    <div className="col-md-8" style={{ padding: "0" }}>
                        <div className={monitorado.parametros?.length === 0 ? "hdv-noshow-item" : "screen-status-options status-date-picker"}>
                            <GenericDatePicker
                                value={datePicker.grafico}
                                onChange={(e) => this.handleSelectDate(e, "grafico")}
                                onApply={() => this.getDataByDay("grafico")}
                                showLabel
                                emitOnMount
                                datepickerStyle={{ padding: "0" }}
                                toggleStyle={{
                                    backgroundColor: "#f8f8f8",
                                    boxShadow: "0 0px 4px rgba(0,0,0,.45)",
                                    top: "7px",
                                    right: "8px",
                                    color: "#444",
                                }}
                                panelStyle={{ top: "50px", right: "8px" }}
                            />
                        </div>

                        {(!this.state.chartLoading && this.state.chart && isBarChart) && <label style={{
                            position: "absolute",
                            zIndex: 1,
                            fontSize: "16px",
                            fontWeight: 600,
                            top: "4px",
                            left: "5px",
                        }}>
                            <i
                                className="las la-info-circle"
                                style={{ cursor: "pointer" }}
                                title={getVolumeChartGroupByMessage(chartGroup)?.title}
                                onClick={() => helper.dispatchEvent("showAviso", {
                                    message: getVolumeChartGroupByMessage(chartGroup)?.message
                                })}
                            >
                            </i>
                        </label>}

                        {this.state.chartLoading
                            ?
                            <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ height: "330px", paddingLeft: "24px", paddingTop: "30px" }}>
                                <ReactLoading className="hdv-report-loading" type="spin" color="var(---background-menu)" width={35} />
                            </div>
                            :
                            monitorado.parametros?.length === 0 ?
                                <p style={{ textAlign: "center", marginTop: "150px", opacity: "0.85", fontSize: "14px", userSelect: "none" }}>
                                    Sem parametros para exibir
                                </p>
                                :
                                <>{this.state.chart}</>
                        }
                    </div>
                    <div style={{ paddingRight: "0px" }} className="map-status col-md-4">
                        <button id="map-details" onClick={() => this.handleModal("mapa")} style={{zIndex: "1"}}>
                            <i className="fa fa-expand fa-2x"></i>
                        </button>
                        <Mapa
                            position={this.state.position}
                            allowDragging={false}
                            allowZoom={false}
                            layerControl={false}
                            markers={this.state.map.markers}
                            style={{ height: "380px", top: "0", zIndex: "0" }}
                            onLoad={(ref) => { this.mapRef = ref }}
                        />
                    </div>
                </div>

                <div
                    id="list-comando"
                    className="fields-list"
                    style={{ display: this.state.comandos?.length > 0 ? "flex" : "none"}}>
                    <div id='slide-comando' className="fields-slide">
                        {this.state.comandos?.map((comando, index) => (
                            <CardComando width="300px" detalhes={comando.equipamento} getComandos={this.getComandos} comando={comando} key={index} compact />
                        ))}
                    </div>
                    <div
                        style={{ display: (this.state.actualMoveSlidesComando == this.state.totalMoveSlidesComando) ? "none" : "flex", height: "200px" }}
                        onClick={() => this.slideMove(true, "comando")}
                        className="fields-box-move fields-box-move-right">
                        <i className="fa fa-angle-right fa-2x"></i>
                    </div>
                    <div
                        style={{ display: (this.state.actualMoveSlidesComando == 0) ? "none" : "flex" }}
                        onClick={() => this.slideMove(false, "comando")}
                        className="fields-box-move fields-box-move-left">
                        <i className="fa fa-angle-left fa-2x"></i>
                    </div>
                </div>

                <div className={monitorado?.equipamentos?.length === 0 ? "hdv-noshow-item" : ""} style={{ position: "relative" }}>
                    <Tabs selectedIndex={this.state.tabs.equipamentos} onSelect={(i) => this.handleTab("equipamentos", i)}>
                        <TabList className="react-tabs__tab-list">
                            {monitorado?.equipamentos.map((equipamento, index) => 
                                <Tab key={index}>
                                    {
                                        this.state.tabs.equipamentos == index 
                                        ?
                                        <Link 
                                            to={`/equipamento/${equipamento.id}/editar?back_to=/status/${this.props.match.params.id}`} 
                                            title='Editar Equipamento'
                                            className='status-equipamentos-tabs'
                                        >
                                            {equipamento.imei}
                                        </Link>
                                        :
                                        equipamento.imei
                                    }
                                </Tab>
                            )}
                        </TabList>

                        {monitorado?.equipamentos.map((equipamento) => {
                            const { reportes } = this.state

                            const data = reportes[equipamento.imei] ? reportes[equipamento.imei]?.data : []
                            const columns = reportes[equipamento.imei] ? reportes[equipamento.imei]?.columns : []

                            return (
                                <TabPanel key={equipamento.id}>                 
                                    <div className="screen-status-options status-date-picker">
                                        <label htmlFor="auto-reload">
                                            <input
                                                type="checkbox"
                                                id="auto-reload"
                                                checked={this.state.autoReload}
                                                onChange={(e) => this.setState({ autoReload: e.target.checked })}
                                            />
                                            Atualização automática
                                        </label>
                                        <GenericDatePicker
                                            value={datePicker.eventos}
                                            onChange={(e) => this.handleSelectDate(e, "eventos")}
                                            onApply={() => this.getDataByDay("eventos")}
                                            emitOnMount
                                            datepickerStyle={{ padding: "0" }}
                                            toggleClass={"date-range-selection"}
                                            panelClass={"hdv-datepicker"}
                                        />
                                    </div>

                                    <div className="hdv-btn-group mt-0">
                                        <GenericDatePicker
                                            value={datePicker.csv}
                                            onChange={(e) => this.handleSelectDate(e, "csv")}
                                            onApply={() => this.generateCSV(equipamento)}
                                            emitOnMount
                                            toggleText="Exportar CSV"
                                            applyText="Gerar CSV"
                                            disableApply={this.state.buttonCsv}
                                            datepickerStyle={{ padding: "0" }}
                                            toggleClass="hdv-btn-blue"
                                            toggleStyle={{
                                                position: "relative",
                                                fontWeight: "700",
                                                color: "#fff",
                                                padding: "7px 26px"
                                            }}
                                            panelClass="hdv-datepicker"
                                            panelStyle={{ top: "102px", left: "0" }}
                                            applyStyle={{ backgroundColor: "#4DA060", color: "#fff", border: "none" }}
                                        />
                                    </div>

                                    <Table
                                        noFooter
                                        notEditFirstColum={true}
                                        search={false}
                                        config={false}
                                        data={data}
                                        loading={this.state.loading}
                                        next={this.state.next}
                                        previous={this.state.previous}
                                        columns={columns}
                                        disableRefreshButton={true}
                                        onFetchData={(_) => this.getReports(equipamento, true)}
                                        onUpdate={(table) => this.setState({ table })}
                                        hasLoadMore={true}
                                    />
                                    <div className="report-table-pagination">
                                        <button
                                            disabled={data.length === 0 || disableLoadMore || isDemoMode}
                                            style={{ cursor: isDemoMode ? 'not-allowed' : 'pointer' }}
                                            onClick={() => {
                                                if (demoSession.isActive()) return
                                                this.setState({ pageSize: pageSize + rowLimitSelected })
                                                setTimeout(() => {
                                                    this.state?.table?.fetch()
                                                }, 300)
                                            }}
                                        >
                                            Carregar Mais
                                        </button>
                                        <select
                                            disabled={isDemoMode}
                                            value={rowLimitSelected}
                                            onChange={(event) => {
                                                if (demoSession.isActive()) return
                                                this.setState({ rowLimitSelected: Number(event.target.value) })
                                            }}
                                        >
                                            <option value="10">10 linhas</option>
                                            <option value="20">20 linhas</option>
                                            <option value="50">50 linhas</option>
                                            <option value="100">100 linhas</option>
                                        </select>
                                    </div>
                                </TabPanel>
                            )
                        }
                        )}
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default MonitoradoStatus
